
const CUSTOM_FAVICONS = [
  {
    domain: "estimates.whitelabelcoders.com",
    faviconUrl: "https://whitelabelcoders.com/app/themes/wlc-new-site/dist/images/favicon/favicon-32x32_f7102d9c.png",
  }
]

export const setCustomCompanyFavicon = () => {
  if(!self.location.href.includes("app.apropo")) {
    const usedFavicon = CUSTOM_FAVICONS.find(f => self.location.href.includes(f.domain));
    
    const favicon = document.getElementById("favicon");
    favicon.setAttribute("href", usedFavicon?.faviconUrl || "data:;base64,iVBORw0KGgo=");
  }
}